import React from 'react';

export function PhoneMockup({ children }) {
    return (
        <div className="relative max-w-[320px] w-full mx-auto">
            {/* Teléfono */}
            <div className="bg-black rounded-[40px] p-3 shadow-2xl">
                <div className="bg-black rounded-[28px] overflow-hidden aspect-[9/19] relative">
                    {children}
                </div>
            </div>
            {/* Notch (más realista) */}
            <div className="absolute top-4 left-1/2 -translate-x-1/2 w-32 h-6 bg-black rounded-full flex items-center justify-center">
                <div className="w-10 h-1 bg-gray-800 rounded-full" /> {/* Speaker */}
            </div>
            {/* Botón lateral (volumen) */}
            <div className="absolute -right-1 top-24 w-1.5 h-12 bg-gray-700 rounded-r-full" />
            <div className="absolute -right-1 top-40 w-1.5 h-6 bg-gray-700 rounded-r-full" />
            {/* Botón lateral (power) */}
            <div className="absolute -left-1 top-24 w-1.5 h-8 bg-gray-700 rounded-l-full" />
        </div>
    );
}